import { defineMessages } from 'react-intl';
import { SportTermLookup, SportTerminology } from '../../../lib/types';
import { pluralTerm } from '../../../lib/helpers/term.helper';

export const scope = 'app.components.SessionPlayerNotificationToggle';

export const getMessages = (termLookup: SportTermLookup) => {
  const session = termLookup[SportTerminology.SESSION];
  const athletes = pluralTerm(termLookup[SportTerminology.ATHLETE]).toLowerCase();
  return defineMessages({
    lblNotify: {
      id: `${scope}.lblNotify`,
      defaultMessage: `Send ${session} Update Notifications`
    },
    tipNotify: {
      id: `${scope}.tipNotify`,
      defaultMessage: `When on, ${athletes} added to or removed from this ${session.toLowerCase()} are notified, and every ${termLookup[SportTerminology.ATHLETE].toLowerCase()} is notified when its details change. Saved for this ${session.toLowerCase()}.`
    },
    errNotSaved: {
      id: `${scope}.errNotSaved`,
      defaultMessage: `The notification setting wasn't saved. Try again.`
    }
  });
};
